var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":{ path: item.path === '' ? '/' : item.path}}},[_vm._v(_vm._s(item.meta.title))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }